import UsersApi from "Classes/API/UsersApi";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";

const UserTypeSelector = ({ setUserType, placeholder, initialValue = null }) => {
  const [UsersSearch, setUserSearch] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState(
    initialValue ? { value: initialValue, label: initialValue } : null
  );

  const GetUserTypes = async (inputValue = "") => {
    try {
      let res = await UsersApi.GetUserTypes();
      if (res.status === "Success") {
        let optionsArr = res.data.map((item) => ({
          value: item,
          label: item,
        }));

        if (inputValue) {
          return optionsArr.filter((option) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
          );
        }
        return optionsArr;
      }
      return [];
    } catch (error) {
      console.error("Error fetching user types:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchUserTypes = async () => {
      const optionsArr = await GetUserTypes("");
      setOptions(optionsArr);

      if (initialValue && optionsArr.length > 0) {
        const foundOption = optionsArr.find((opt) => opt.value === initialValue);
        if (foundOption) {
          setSelectedUserType(foundOption);
        }
      }
    };
    fetchUserTypes();
  }, [initialValue]);

  const handleChange = (selectedOption) => {
    setSelectedUserType(selectedOption);
    setUserType(selectedOption?.value || null); // Proper null handling
  };

  return (
    <MDTypography variant="button" fontWeight="regular" color="text">
      <AsyncSelect
        isClearable={true}
        cacheOptions
        loadOptions={GetUserTypes}
        onInputChange={setUserSearch}
        onChange={handleChange}
        value={selectedUserType}
        placeholder={placeholder}
        defaultOptions={options}
        styles={{
          control: (provided) => ({
            ...provided,
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999, // Ensure dropdown appears above other elements
          }),
        }}
      />
    </MDTypography>
  );
};

export default UserTypeSelector;
